import __request__ from "routing/request";
export function list(skip = 0, limit = 0, stats = false, only_open = false, requestOptions) {
  return __request__("GET", "/system/indices/index_sets", null, { "skip": skip, "limit": limit, "stats": stats, "only_open": only_open }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function save(Indexsetconfiguration, requestOptions) {
  return __request__("POST", "/system/indices/index_sets", Indexsetconfiguration, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function search(skip = 0, limit = 0, searchTitle, stats = false, requestOptions) {
  return __request__("GET", "/system/indices/index_sets/search", null, { "searchTitle": searchTitle, "skip": skip, "limit": limit, "stats": stats }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function globalStats(requestOptions) {
  return __request__("GET", "/system/indices/index_sets/stats", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(id, Indexsetconfiguration, requestOptions) {
  return __request__("PUT", `/system/indices/index_sets/${id}`, Indexsetconfiguration, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(id, requestOptions) {
  return __request__("GET", `/system/indices/index_sets/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, delete_indices = true, requestOptions) {
  return __request__("DELETE", `/system/indices/index_sets/${id}`, null, { "delete_indices": delete_indices }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setDefault(id, requestOptions) {
  return __request__("PUT", `/system/indices/index_sets/${id}/default`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function indexSetStatistics(id, requestOptions) {
  return __request__("GET", `/system/indices/index_sets/${id}/stats`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
